import { Box, Typography } from "@mui/material";
import React from "react";
import moment from "moment-timezone";
import List from "../../../components/List";
import { EmptyView } from "../../../components/OList";
import { notificationAdd } from "../../../actions/notification";
import { errorFetchMessage, MODULE } from "../../../helpers/messages";
import { useAppDispatch } from "../../../store/hooks";
import { ConsentData } from "./ConsentCreateEditForm";
import { getConsentForms } from "../../../api/consentForm";

interface Props {
  clientId: number;
  onRowClick: (value: ConsentData) => void;
}
const ConsentFormList = ({ clientId, onRowClick }: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const [data, setData] = React.useState<ConsentData[]>([]);

  React.useEffect(() => {
    (async () => {
      try {
        const response = await getConsentForms(clientId);
        setData(response);
      } catch (e) {
        dispatch(
          notificationAdd({
            id: new Date().getTime(),
            message: errorFetchMessage(MODULE.CONSENT_FORM),
            variant: "error",
            autoTimeout: true
          })
        );
      }
    })();
  }, [clientId]);

  return (
    <List
      automation="estimatesList"
      withoutSearch
      hideCreateButton
      rowHeight={40}
      data={data}
      adjustHeightToContents
      onRowClick={(row: ConsentData) => {
        onRowClick(row);
      }}
      columns={[
        {
          key: "created_at",
          label: "Date",
          // eslint-disable-next-line camelcase
          formatter: ({ created_at }) => (
            <Typography>{moment(created_at).format("DD-MM-YYYY")}</Typography>
          )
        },
        {
          key: "isAccepted",
          label: "Accepted",
          formatter: ({ isAccepted }) => <Typography>{isAccepted ? "Yes" : "No"}</Typography>
        },
        {
          key: "signatureId",
          label: "Signed",
          formatter: ({ signatureId }) => <Typography>{signatureId ? "Yes" : "No"}</Typography>
        }
      ]}
    >
      <EmptyView>
        <Box fontSize="0.7rem" marginTop="16px" display="flex" justifyContent="center">
          No consent form created for the client yet...
        </Box>
      </EmptyView>
    </List>
  );
};

export default ConsentFormList;
